export default {
  outputTemplate: 'Output template',
  createCategory: 'Add new category',
  createCategoryHelp: 'Press <kbd>enter</kbd> to save',
  availabilityState: 'Hi availability state',
};
